'use strict';

(
    function($)
    {
        $.fn.tab = function(params)
        {
            $(this).each
            (
                function()
                {
                    params.triggers.click
                    (
                        function()
                        {
                            const $content = params.contents.filter("[data-tab-content='" + $(this).data("tab-trigger") + "']");

                            if(params.click) params.click($(this), $content);
                        }
                    );
                }
            );
        }
    }
)(jQuery);
